export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

export const validateEmail = (email) => {
  return EMAIL_REGEX.test(email);
};

export const createTrimHandler = (
  setValue,
  fieldName,
  shouldValidate = true
) => {
  return (e) => {
    setValue(fieldName, e.target.value.trim(), {
      shouldValidate,
    });
  };
};

export const createErrorHandler = (setError, title, message) => {
  return () => {
    setError({
      title,
      message,
    });
  };
};

/**
 * Extracts a display string from an axios error returned by the booking-page
 * API. Prefers the backend's `details` array (joined), then its `message`,
 * then the provided fallback.
 *
 * Backend error shape: { error: { message, code?, details? } }
 *
 * @param {Error} err - The axios error.
 * @param {string} fallback - Message shown when the error carries no text.
 * @returns {string}
 */
export const buildApiErrorMessage = (err, fallback) => {
  const details = err?.response?.data?.error?.details;
  if (details && Array.isArray(details)) return details.join(", ");
  return err?.response?.data?.error?.message || fallback;
};
